(function () {
    "use strict";

    class ConvxPdpMedia extends HTMLElement {
        constructor() {
            super();
            this.colorInputsWrap = document.querySelector(
                '.variant-input-wrap[name="Color"]'
            );
            this.colorInputs = this.colorInputsWrap
                ? [
                    ...this.colorInputsWrap.querySelectorAll(
                        '[data-handle="color"] .variant-input'
                    ),
                ]
                : [];
            if (this.colorInputs.length === 0) {
                this.colorInputsWrap = document.querySelector(
                    '.variant-input-wrap[name="Size"]'
                );
                this.colorInputs = this.colorInputsWrap
                    ? [
                        ...this.colorInputsWrap.querySelectorAll(
                            '[data-handle="size"] .variant-input'
                        ),
                    ]
                    : [];
            }
            this.threeSixties = [
                ...this.querySelectorAll("convx-pdp-media [data-color-value]"),
            ];
            this.productImages = this.querySelector("[data-product-images]");
            this.originalImageContainer = this.parentElement.querySelector(
                "[data-product-images]"
            );
        }

        connectedCallback() {
            window.addEventListener("DOMContentLoaded", () => {
                this.init();
                this.bindEvents();
            });
        }

        init() {
            const selectedInput = this.getSelectedInput();
            const selectedValue = selectedInput?.getAttribute("data-value");
            if (selectedValue) {
                this.showMatchingMedia(selectedValue);
            } else {
                this.showProductImagesOnly();
            }
        }

        bindEvents() {
            if (this.colorInputs && this.colorInputs.length > 0) {
                this.originalImageContainer.style.display = "none";

                this.colorInputs.forEach((input) => {
                    input.addEventListener("change", () => {
                        const value = input.getAttribute("data-value");
                        this.showMatchingMedia(value);
                    });
                });
            }
        }

        getSelectedInput() {
            return this.colorInputs.find((input) => {
                const radio = input.querySelector('input[type="radio"]');
                return radio?.checked;
            });
        }

        showMatchingMedia(value) {
            let found = false;

            this.threeSixties.forEach((media) => {
                if (media.getAttribute("data-color-value") === value) {
                    media.classList.add("active");
                    media.style.display = "";
                    found = true;
                } else {
                    media.classList.remove("active");
                    media.style.display = "none";
                }
            });

            if (this.productImages) {
                this.productImages.style.display = found ? "none" : "";
            }
        }

        showProductImagesOnly() {
            this.threeSixties.forEach((media) => {
                media.classList.remove("active");
                media.style.display = "none";
            });

            if (this.productImages) {
                this.productImages.style.display = "";
            }
        }
    }

    class ConvxPdpVariant extends HTMLElement {
        constructor() {
            super();
            this.flickityInstance = null;
            this._hasResizeListener = false;
            this.boundUpdateFlickity = this.debounce(
                this.updateFlickity.bind(this),
                200
            );
            this._boundResizeHandler = this.updateFlickity.bind(this);
            this.windowWidth = window.innerWidth;
        }

        connectedCallback() {
            this.initFlickity();

            window.addEventListener("resize", this._boundResizeHandler);

            this.initSelectedVariant();
            this.addEventListener("change", this.handleVariantChange.bind(this));
            imagesLoaded(this, () => {
                this.flickityInstance.resize();
                this.flickityInstance.reloadCells();
            });
        }

        // connectedCallback() {
        //   this.initFlickity();

        //   // Add resize listener only once
        //   if (!this._hasResizeListener) {
        //     window.addEventListener("resize", this.boundUpdateFlickity);
        //     this._hasResizeListener = true;
        //   }

        //   this.initSelectedVariant();

        //   this.addEventListener("change", this.handleVariantChange.bind(this));
        // }

        disconnectedCallback() {
            window.removeEventListener("resize", this.updateFlickity.bind(this));
            if (this.flickityInstance) {
                this.flickityInstance.destroy();
            }
            this.removeEventListener("change", this.handleVariantChange.bind(this));
        }

        // disconnectedCallback() {
        //   if (this._hasResizeListener) {
        //     window.removeEventListener("resize", this.boundUpdateFlickity);
        //     this._hasResizeListener = false;
        //   }

        //   if (this.flickityInstance) {
        //     this.flickityInstance.destroy();
        //     this.flickityInstance = null;
        //   }

        //   this.removeEventListener("change", this.handleVariantChange.bind(this));
        // }

        initSelectedVariant() {
            const checkedRadio = this.querySelector('input[type="radio"]:checked');
            if (!checkedRadio) return;

            const value = checkedRadio.value;

            const wrapper = this.closest("convx-pdp-variant");
            if (!wrapper) return;

            const displayElement = wrapper.parentElement.parentElement.querySelector(
                ".convx__current-selected-variant"
            );
            if (displayElement) {
                displayElement.textContent = value;
            }
        }

        handleVariantChange(event) {
            const radio = event.target;
            if (radio.type !== "radio" || !radio.checked) return;

            const value = radio.value;

            // Find closest ConvxPdpVariant parent
            const wrapper = this.closest("convx-pdp-variant");
            if (!wrapper) return;

            // Find sibling element with class .convx__current-selected-variant
            const displayElement = wrapper.parentElement.parentElement.querySelector(
                ".convx__current-selected-variant"
            );
            if (displayElement) {
                displayElement.textContent = value;
            }
        }

        debounce(fn, delay) {
            let timeout;
            return (...args) => {
                clearTimeout(timeout);
                timeout = setTimeout(() => fn.apply(this, args), delay);
            };
        }

        getFlickityOptions() {
            return window.innerWidth < 768
                ? {
                    cellAlign: "left",
                    contain: true,
                    groupCells: true,
                    draggable: true,
                    prevNextButtons: true,
                    pageDots: true,
                    freeScroll: true,
                    percentPosition: true,
                    wrapAround: false,
                    imagesLoaded: true,
                }
                : {
                    cellAlign: "left",
                    contain: true,
                    groupCells: true,
                    draggable: true,
                    prevNextButtons: true,
                    pageDots: true,
                    freeScroll: true,
                    percentPosition: true,
                    wrapAround: false,
                    imagesLoaded: true,
                };
        }

        initFlickity() {
            if (this.flickityInstance) {
                this.flickityInstance.destroy();
            }

            // Avoid initializing if there are no child elements (like in SSR timing)
            if (this.children.length === 0) return;

            this.flickityInstance = new Flickity(this, this.getFlickityOptions());
        }

        updateFlickity() {
            if (window.innerWidth !== this.windowWidth) {
                this.windowWidth = window.innerWidth;
                this.initFlickity();
            }
        }
    }

    class ConvxTabImageContent extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            const tabs = this.querySelectorAll(".convx__tab");
            const contents = this.querySelectorAll(".convx__tab-content");

            tabs.forEach((tab) => {
                tab.addEventListener("click", () => {
                    const tabId = tab.getAttribute("data-tab");

                    tabs.forEach((t) => t.classList.remove("is-active"));
                    contents.forEach((c) => c.classList.remove("is-active"));

                    tab.classList.add("is-active");
                    this.querySelector(
                        `.convx__tab-content[data-tab="${tabId}"]`
                    ).classList.add("is-active");
                });
            });
        }
    }

    class UpholsterySelector {
        constructor(container) {
            this.container = container;
            this.label = container.querySelector(".upholstery-current-label");
            this.options = container.querySelectorAll(".upholstery-option");

            this.init();
            this.initModal();
        }

        init() {
            this.options.forEach((option) => {
                option.addEventListener("click", () => this.selectOption(option));
            });
        }

        selectOption(selectedOption) {
            this.options.forEach((option) => {
                option.classList.remove("selected");
                const existingCheck = option.querySelector(".check-icon");
                if (existingCheck) existingCheck.remove();
            });

            selectedOption.classList.add("selected");
            this.label.textContent = selectedOption.dataset.material;

            const check = document.createElement("div");
            check.className = "check-icon";
            check.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" class="svg-icon" style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1"><path d="M887.904 298.208c-12.864-12.064-33.152-11.488-45.216 1.408L415.936 753.984l-233.12-229.696C170.208 511.872 149.952 512 137.536 524.608c-12.416 12.576-12.256 32.864 0.352 45.248l256.48 252.672c0.096 0.096 0.224 0.128 0.32 0.224 0.096 0.096 0.128 0.224 0.224 0.32 2.016 1.92 4.448 3.008 6.784 4.288 1.152 0.672 2.144 1.664 3.36 2.144 3.776 1.472 7.776 2.24 11.744 2.24 4.192 0 8.384-0.832 12.288-2.496 1.312-0.544 2.336-1.664 3.552-2.368 2.4-1.408 4.896-2.592 6.944-4.672 0.096-0.096 0.128-0.256 0.224-0.352 0.064-0.096 0.192-0.128 0.288-0.224l449.184-478.208C901.44 330.592 900.768 310.336 887.904 298.208z"/></svg>`;
            selectedOption.appendChild(check);
        }

        initModal() {
            const openModalBtn = document.querySelector(".upholstery-guide");
            const modal = document.getElementById("upholsteryModal");
            const closeModalBtn = modal?.querySelector(".modal-close");
            const overlay = modal?.querySelector(".modal-overlay");

            if (openModalBtn && modal && closeModalBtn && overlay) {
                openModalBtn.addEventListener("click", () => {
                    modal.style.display = "flex";
                });

                closeModalBtn.addEventListener("click", () => {
                    modal.style.display = "none";
                });

                overlay.addEventListener("click", () => {
                    modal.style.display = "none";
                });
            }
        }
    }

    function renderRatingCells() {
        const ratingIcons = {
            breathability: `https://cdn.shopify.com/s/files/1/2021/9723/files/Air_white.png?v=1754028660`,
            softness: `https://cdn.shopify.com/s/files/1/2021/9723/files/Feather_white.png?v=1754028660`,
            premium: `https://cdn.shopify.com/s/files/1/2021/9723/files/Diamond.png?v=1747067743`,
        };
        const renderStars = (rating, cat) => {
            const stars = [];
            const icon = ratingIcons[cat];
            for (let i = 1; i <= rating; i++) {
                stars.push(`<img src="${icon}" width="25">`);
            }
            return stars.join("");
        };
        const categories = ["softness", "breathability", "premium"];
        categories.forEach((cat) => {
            document.querySelectorAll(`.${cat}`).forEach((cell) => {
                const rate = parseFloat(cell.dataset[`${cat}Rate`]);
                const container = cell.querySelector("div");
                if (container) {
                    container.innerHTML = renderStars(rate, cat);
                }
            });
        });
    }

    class ConvxUpholstery extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.label = this.querySelector(".upholstery-current-label");
            this.options = this.querySelectorAll(".upholstery-option");

            this.options.forEach((option) => {
                option.addEventListener("click", () => this.selectOption(option));
            });

            this.initModal();
            renderRatingCells();
        }

        renderRatings() {
            renderRatingCells();
        }

        initModal() {
            const openModalBtn = document.querySelector(".upholstery-guide");
            const modal = document.getElementById("upholsteryModal");
            const closeModalBtn = modal?.querySelector(".modal-close");
            const overlay = modal?.querySelector(".modal-overlay");

            if (openModalBtn && modal && closeModalBtn && overlay) {
                openModalBtn.addEventListener("click", () => {
                    modal.classList.add("visible");
                });

                const close = () => modal.classList.remove("visible");

                closeModalBtn.addEventListener("click", close);
                overlay.addEventListener("click", close);
            }
        }

        selectOption(selectedOption) {
            this.options.forEach((option) => {
                option.classList.remove("selected");
                const existingCheck = option.querySelector(".check-icon");
                if (existingCheck) existingCheck.remove();
            });

            selectedOption.classList.add("selected");
            if (this.label) {
                this.label.textContent = selectedOption.dataset.material;
            }

            const check = document.createElement("div");
            check.className = "check-icon";
            check.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" class="svg-icon" style="width: 1em; height: 1em; vertical-align: middle; fill: currentColor; overflow: hidden;" viewBox="0 0 1024 1024">
        <path d="M887.904 298.208c-12.864-12.064-33.152-11.488-45.216 1.408L415.936 753.984l-233.12-229.696C170.208 511.872 149.952 512 137.536 524.608c-12.416 12.576-12.256 32.864 0.352 45.248l256.48 252.672c..."/>
      </svg>
    `;
            selectedOption.appendChild(check);
        }

        initModal() {
            const openModalBtn = document.querySelector(".upholstery-guide");
            const modal = document.getElementById("upholsteryModal");
            const closeModalBtn = modal?.querySelector(".modal-close");
            const overlay = modal?.querySelector(".modal-overlay");

            if (openModalBtn && modal && closeModalBtn && overlay) {
                openModalBtn.addEventListener("click", () => {
                    modal.style.display = "flex";
                });

                closeModalBtn.addEventListener("click", () => {
                    modal.style.display = "none";
                });

                overlay.addEventListener("click", () => {
                    modal.style.display = "none";
                });
            }
        }
    }

    class ConvxArmrest extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.label = this.querySelector(".armrest-current-label");
            this.options = this.querySelectorAll(".armrest-option");

            this.options.forEach((option) => {
                option.addEventListener("click", () => this.selectOption(option));
            });

            this.initModal();
            renderRatingCells();
        }

        renderRatings() {
            renderRatingCells();
        }

        initModal() {
            const openModalBtn = document.querySelector(".armrest-guide");
            const modal = document.getElementById("armrestModal");
            const closeModalBtn = modal?.querySelector(".modal-close");
            const overlay = modal?.querySelector(".modal-overlay");

            if (openModalBtn && modal && closeModalBtn && overlay) {
                openModalBtn.addEventListener("click", () => {
                    modal.classList.add("visible");
                });

                const close = () => modal.classList.remove("visible");

                closeModalBtn.addEventListener("click", close);
                overlay.addEventListener("click", close);
            }
        }

        selectOption(selectedOption) {
            this.options.forEach((option) => {
                option.classList.remove("selected");
                const existingCheck = option.querySelector(".check-icon");
                if (existingCheck) existingCheck.remove();
            });

            selectedOption.classList.add("selected");
            if (this.label) {
                this.label.textContent = selectedOption.dataset.material;
            }

            const check = document.createElement("div");
            check.className = "check-icon";
            check.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" class="svg-icon" style="width: 1em; height: 1em; vertical-align: middle; fill: currentColor; overflow: hidden;" viewBox="0 0 1024 1024">
        <path d="M887.904 298.208c-12.864-12.064-33.152-11.488-45.216 1.408L415.936 753.984l-233.12-229.696C170.208 511.872 149.952 512 137.536 524.608c-12.416 12.576-12.256 32.864 0.352 45.248l256.48 252.672c..."/>
      </svg>
    `;
            selectedOption.appendChild(check);
        }

        initModal() {
            const openModalBtn = document.querySelector(".armrest-guide");
            const modal = document.getElementById("armrestModal");
            const closeModalBtn = modal?.querySelector(".modal-close");
            const overlay = modal?.querySelector(".modal-overlay");

            if (openModalBtn && modal && closeModalBtn && overlay) {
                openModalBtn.addEventListener("click", () => {
                    modal.style.display = "flex";
                });

                closeModalBtn.addEventListener("click", () => {
                    modal.style.display = "none";
                });

                overlay.addEventListener("click", () => {
                    modal.style.display = "none";
                });
            }
        }
    }
    class ConvxDropDown extends HTMLElement {
        constructor() {
            super();

            this.toggle = this.toggle.bind(this);
        }

        connectedCallback() {
            this.header = this.querySelector(".dropdown-header");
            this.content = this.querySelector(".dropdown-content");
            this.icon = this.querySelector(".accordion-icon");
            const box = document.querySelector(".custom-offer-box");

            if (this.header && this.content) {
                this.header.style.cursor = "pointer";
                this.header.addEventListener("click", this.toggle);

                this.content.style.maxHeight = "unset";
                this.content.style.overflow = "hidden";
                this.content.style.transition = "max-height 0.3s ease";

                if (window.innerWidth <= 540) {
                    this.instalment = this.querySelector(".instalment");
                    if (box) {
                        console.log('box');
                        if (box.classList.contains("open")) {
                            console.log('open');
                            box.classList.remove("open");
                        }
                    }
                }
            }
        }

        toggle() {
            this.classList.toggle("open");

            this.icon = this.querySelector(".accordion-icon");

            if (this.classList.contains("open")) {
                // this.content.style.maxHeight = this.content.scrollHeight + "px";
                this.content.style.maxHeight = "unset";
                this.icon.innerHTML = ` <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="3"
                viewBox="0 0 15 3"
                fill="none">
                <path
                  d="M1.84315 1.65685L13.1876 1.68757"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>`;
            } else {
                this.content.style.maxHeight = "0";
                this.icon.innerHTML = ` <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
    <path d="M1.84315 6.65685L13.1876 6.68757" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7.65685 12.317L7.66017 0.999984" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg> `;
            }
        }

        disconnectedCallback() {
            if (this.header) {
                this.header.removeEventListener("click", this.toggle);
            }
        }
    }

    function onDOMContentLoaded() {
        const path = location.pathname;
        const isHomePage = path == "/";
        const isProducts = path.includes("/products");
        const isCollections = path.includes("/collections") && !isProducts;
        const isCart = path == "/cart";

        if (isProducts) {
            customElements.define("convx-pdp-media", ConvxPdpMedia);
            customElements.define("convx-pdp-variant", ConvxPdpVariant);
            // document.querySelectorAll("[data-upholstery-component]").forEach((container) => {
            //   new UpholsterySelector(container);
            // });
            customElements.define("convx-upholstery", ConvxUpholstery);
            customElements.define("convx-armrest", ConvxArmrest);
            renderRatingCells();
        }
        customElements.define("convx-tab-image-content", ConvxTabImageContent);
        customElements.define("convx-drop-down", ConvxDropDown);
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", onDOMContentLoaded, {
            once: true,
        });
    } else {
        onDOMContentLoaded();
    }
})();